// Module
var code = "<div class=\"bSpinner\" ng-class=\"{background: !bSpinner.noBackground}\"> <i class=\"bSpinner__spinner\"></i> </div>";
// Exports
module.exports = code;